import { SHORTCUT_MAIN_PAGE_CONFIG_FIELDS } from '@@partner:graphql/shortcuts'
import { RemoteMainPageConfig } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useLazyQuery, useQuery } from '@apollo/client'


export interface SingleMainPageConfigQuery {
  singleMainPageConfig: RemoteMainPageConfig
}
export interface SingleMainPageConfigQueryVariables {
  id?: GQL_ID | null
}
export const GQL_QUERY_SINGLE_MAIN_PAGE_CONFIG = gql`
  query singleMainPageConfig (
    $id: ID!
  ) {
    singleMainPageConfig(id: $id) {
      ${SHORTCUT_MAIN_PAGE_CONFIG_FIELDS}
    }
  }
`
export const useFetchSingleMainPageConfig = (
  variables: SingleMainPageConfigQueryVariables
) => {
  return useQuery<SingleMainPageConfigQuery, SingleMainPageConfigQueryVariables>(
    GQL_QUERY_SINGLE_MAIN_PAGE_CONFIG,
    {
      variables,
      skip: !variables.id
    }
  )
}

export const useLazyFetchSingleMainPageConfig = (
  variables?: SingleMainPageConfigQueryVariables
) => {
  return useLazyQuery<SingleMainPageConfigQuery, SingleMainPageConfigQueryVariables>(
    GQL_QUERY_SINGLE_MAIN_PAGE_CONFIG,
    {
      variables
    }
  )
}